<div class="lg:flex justify-center flex-col">
  <div class="p-2 md:p-6 container mx-auto">
    <router-outlet></router-outlet>
  </div>
</div>


